// GHL Cache Composable

// Simple in-memory cache for GHL data
const cache = new Map()
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutes

export default function useGhlCache() {
  const getCacheKey = (url) => url

  const getCachedData = (url) => {
    const key = getCacheKey(url)
    const cached = cache.get(key)

    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      return cached.data
    }

    // Remove expired cache
    if (cached) {
      cache.delete(key)
    }

    return null
  }

  const setCachedData = (url, data) => {
    const key = getCacheKey(url)
    cache.set(key, {
      data,
      timestamp: Date.now()
    })
  }

  const clearCache = () => {
    cache.clear()
  }

  const cachedFetch = async(url, options = {}) => {
    // Add CSRF token to all requests
    const defaultOptions = {
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
        ...options.headers
      },
      ...options
    }

    // Only cache GET requests
    if (!defaultOptions.method || defaultOptions.method === 'GET') {
      const cachedData = getCachedData(url)
      if (cachedData) {
        return {
          ok: true,
          json: async() => cachedData,
          cached: true
        }
      }
    }

    const response = await fetch(url, defaultOptions)

    if (response.ok && (!options.method || options.method === 'GET')) {
      const data = await response.json()
      setCachedData(url, data)
      return {
        ok: true,
        json: async() => data,
        cached: false
      }
    }

    return response
  }

  return {
    cachedFetch,
    clearCache,
    getCachedData,
    setCachedData
  }
}
